<template>
  <div class="detailView">
    <p class="back" @click="backDetail">返回 > </p>
    <p class="title">{{newsItemShow.Title}}</p>
    <!-- <van-divider  class="detailTime">{{newsItemShow.AddTime|timeFormat()}}</van-divider> -->
    <el-divider class="detailTime">{{newsItemShow.AddTime|timeFormat()}}</el-divider>

    <!-- <p class="detailText" v-html="newsItemShow.Content">2021年的终点已在眼前，岁尾年末，不待扬鞭自奋蹄。时空人全力以赴，一路向前！2021年，是时空加速迈向数智化迈向智慧化的一年，专业性更强，效率更高！2021年，是时空的品质之年我们狠抓服务提高品质，取得不俗佳绩！2021年，更是时空的重要转折点为时空长远发展打下坚实基础！

        2021年，亦是不确定因素增多的一年在郑州，我们经历了暴雨的洗礼、新冠的考验…面对挑战，全体时空人直面困难毫不退缩乘风破浪，奋勇争先！

        从2021到2022时空人跨越的不止是时间更是以奋斗之名决战之力一起走向未来！
    </p> -->
        <div class="newsItemShow">
        <div class="newsItemShowTop" v-if="newsItemShow.ArticleType === 1">
            <video  :src="newsItemShow.Video" controls ></video>
        </div>
        <!-- {{newsItemShow.Content}} -->
        <div v-else v-html="newsItemShow.Content"></div>
    </div>

  </div>
</template>

<script>
import { getArticleApiShow } from '@/api/news'
// 引入时间格式过滤
import { timeFormat } from '@/utils/myFilters'
// 引入根路径
import request from '@/utils/request'
export default {
  name: 'detailView',
  data () {
    return {
      newsItemShow: {} // 新闻详情
    }
  },
  filters: {
    timeFormat
  },
  mounted () {
    this.getArticleApiShow({ id: this.$route.params.id })
  },
  methods: {
    backDetail () {
      this.$router.back()
    },
    // 获取新闻详情
    async getArticleApiShow (data) {
      const res = await getArticleApiShow(data)
      // 替换后的前面添加根路径
      const base = request.defaults.baseURL
      // 要截取替换的内容过滤
      const oldBase = '/Upload/Image/'
      if (res.Msg === '获取成功') {
        this.newsItemShow = res.Data
        // this.newsItemShow.Video = request.defaults.baseURL + this.newsItemShow.Video
        this.newsItemShow.Content = this.newsItemShow.Content.replace(/\/Upload\/Image\//g, base + oldBase)
      }
      // console.log(res, '新闻详情')
    }
  }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.detailView{
    padding: 0 30px/$md;
    overflow: hidden;
}
.back{
    display: flex;
    justify-content: flex-end;
height: 35px/$md;
font-size: 26px/$md;
font-weight: 400;
line-height: 24px/$md;
color: #666666;
margin-top: 50px/$md;
margin-bottom: 40px/$md;
}
.title{
    display: flex;
    justify-content: center;
    font-size: 32px/$md;
font-weight: 500;
text-align: center;
// line-height: 23px/$md;
color: #333333;
}
.detailTime{
margin-top: 50px/$md;
margin-bottom: 40px/$md;
}
::v-deep .el-divider__text{
  font-size: 25px/$md;
}
.detailText{
    width: 690px/$md;
font-size: 28px/$md;
font-weight: 400;
line-height: 46px/$md;
color: #666666;
}
.detailImg{
    margin: 40px/$md 0 40px/$md 0;
    width: 690px/$md;
    height: 380px/$md;
}
.image{
    width: 100%;
}
// 富有文本
.newsItemShow{
    width: 690px/$md;
    min-height: 600px/$md;
}
.newsItemShowTop{
    display: flex;
    justify-content: center;
    video {
      width: 600px/$md;
      height: 350px/$md;
    }
}
</style>
